export default class RunOnce {
	static run_once_timer:any;
	static runOnceFunction:Function;
	constructor(){
		RunOnce.run_once_timer = null;
		RunOnce.runOnceFunction = null;
	}

	public static run(fg:Function, time?:number){
        if ( time === undefined) {
            time = 500;
        }
        RunOnce.runOnceFunction = fg;
        if ( RunOnce.run_once_timer === null ) {
            RunOnce.run_once_timer = setTimeout(() => {
                RunOnce.runOnceFunction();
                RunOnce.run_once_timer = null;
            }, time);
        }
    }
}
new RunOnce();
